import { Routes, Route, BrowserRouter } from 'react-router-dom';
import {
  Privacy,
  Terms,
  Verify,
  Analytics,
  Signin,
  Dashboard,
  Home,
  News,
  CompanyDetails,
} from '@/pages/index';
import Highcharts from 'highcharts';
import MainFrameAuth from '@/frames/MainFrameAuth';
import { GRAPH2, BENCHMARKCOLORS } from '@/styles/colorTheme';
import AccountSettingsPage from '@/pages/AccountSettings';

Highcharts.setOptions({
  colors: [...BENCHMARKCOLORS, ...GRAPH2],
  chart: {
    style: {
      fontFamily:
        "'Mulish', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    },
  },
  time: {
    useUTC: false,
    timezone: 'Asia/Seoul',
  },
});

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainFrameAuth />}>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/news" element={<News />} />
          <Route path="/company/:id" element={<CompanyDetails />} />
          <Route path="/analytics/:id?" element={<Analytics />} />
          <Route path="/settings" element={<AccountSettingsPage />} />
        </Route>
        <Route path="privacy" element={<Privacy />} />
        <Route path="verify" element={<Verify />} />
        <Route path="terms" element={<Terms />} />
        <Route path="signup" element={<Signin />} />
        <Route path="signin/:id" element={<Signin />} />
        <Route path="signin/company/:id" element={<Signin />} />
        <Route path="*" element={<Signin />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
